import React from 'react';
import ClearIcon from '@shared/assets/icons/clear.svg';
import { View } from '@shared/components/View';
import { MBIcon } from '@shared/components/image';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { MBChatAttachmentComponent } from '@shared/scenes/chat/thread/components/attachment/index';
import { Colors } from '@shared/styles';
import { Styles, UnvalidatedStyles } from './styles';

const RATIO_16_9 = 1.77;
const RATIO_1_2 = 0.5;

interface MBAttachmentRowProps {
  attachment: MBAPI.ChatAttachment;
  onRemove: (attachment: MBAPI.ChatAttachment) => void;
}

export function MBAttachmentRow({ attachment, onRemove }: MBAttachmentRowProps) {
  const width = getWidth(attachment);
  const height = UnvalidatedStyles.listHeight;

  const onPressRemove = () => {
    onRemove(attachment);
  };

  return (
    <View shrinkWrap style={{ height: height }}>
      <View style={{ width: width, height: height }}>
        <MBChatAttachmentComponent
          fallback="square"
          attachment={attachment}
          containerWidth={width}
          forcedHeight={height}
          backgroundColor={Colors.v2.grayBackground}
        />
      </View>
      <MBRemoveAttachmentButton onPress={onPressRemove} />
    </View>
  );
}

function getWidth(attachment: MBAPI.ChatAttachment): number {
  const forcedHeight = UnvalidatedStyles.listHeight;
  if (!attachment.width || !attachment.height) {
    return forcedHeight;
  }

  const aspectRatio = getAspectRatio(attachment);

  if (aspectRatio < 1) {
    return Math.min(attachment.width, forcedHeight * Math.max(aspectRatio, RATIO_1_2));
  } else {
    return Math.min(attachment.width, forcedHeight * aspectRatio, forcedHeight * RATIO_16_9);
  }
}

function getAspectRatio(attachment: MBAPI.ChatAttachment): number {
  if (!attachment.width || !attachment.height) {
    return 1;
  }
  return attachment.width / attachment.height;
}

export function MBRemoveAttachmentButton({ onPress }: { onPress: () => void }) {
  return (
    <MBTouchableOpacity onPress={onPress} style={Styles.removeButtonPosition}>
      <MBIcon color={Colors.gray.normal} style={Styles.removeButtonIcon} source={ClearIcon} />
    </MBTouchableOpacity>
  );
}
